<template>
  <div class="containerCategories">
    <b-container  v-if="($mq === 'mobile' || $mq === 'tablet')" fluid>
      <b-row class="categoryHeader" :style="{backgroundColor: getCssColor('bg_header')}">
        <b-col>
          <b-row :style="{backgroundColor: getCssColor('bg_header')}">
            <b-col cols="2" class="headerItem">
              <div @click="gotToPath('/home')" style="cursor:pointer;" :style="{color: getCssColor('primary_bt')}">
                <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'chevron-left']"/>
              </div>
            </b-col>
            <b-col cols="6" class="headerItem" style="cursor:pointer;height:60px;position:relative;text-align:center;" :style="{color: getCssColor('header_icon_color')}">
              <div style="line-height:16px;height:32px;position:absolute;top:32%;text-align:center;width:90%;font-weight:500;">{{(name).toUpperCase()}}</div>
            </b-col>
            <b-col cols="2" class="headerItem">
              <div @click="startSearch()" style="cursor:pointer;" :style="{color: getCssColor('header_icon_color')}">
                <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'search']"/>
              </div>
            </b-col>
            <b-col cols="2" class="headerItem" >
              <a href="#/cart" style="position:relative;cursor:pointer;" :style="{color: getCssColor('header_icon_color')}">
                <CartBullet style="top:-15px;"/>
                <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'shopping-cart']"/>
              </a>
            </b-col>
          </b-row>
          <b-row>
            <div class="categoriesBox" style="height:56px;">
              <div class="span5" style="padding:15px;cursor:pointer;" :class="{selectedCat: category.name === name}" @click="gotToPath('/categories/' + category.id)" v-for="(category, idx) in categories" v-bind:key="idx">{{category.name}}</div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    
    

    <template v-else>
      <StoreHeader />
    </template>
    <b-container fluid :style="{marginTop: ( ($mq === 'mobile' || $mq === 'tablet') ? '122px' : '10px')}" style="padding:8px 8px 0px 8px;;width:100%;">
      <b-row>
        <b-col cols="12" class="categotyProductBox" lg="6" xl="4" v-for="(product, idx) in products" v-bind:key="idx" :style="{borderBottom:( $mq === 'mobile' || $mq === 'tablet' ? '1px solid #DAD7D4': '')}">
          <b-row class="categotyProductBoxChild">
            <b-col cols="5" @click="gotToPath('/product/'+product.id)" style="text-align:center;cursor:pointer;">
              <img v-if="product.photos.length" @error="imgUrlAlt" :alt="product.name" class="foto" style="margin:10px;" :src="productImageURI + '/' + product.photos[0].id" />
              <img v-else :alt="product.name" class="foto" style="margin:10px;" src="https://cdnimages.opa4.store/img/fixedimg/no-picture.png" />
              <AtacarejoSticker style="right:8px;bottom:0px;" :productView='product.product_views[0]'/>
              <PromoSticker style="position:absolute;left:7px;top:5px;" v-if="product.product_views[0].promotional_price" :discount="Math.round(100 - ((product.product_views[0].promotional_price / product.product_views[0].price) * 100))" />
            </b-col>
            <b-col cols="7" >
              <div class="nameCapt" style="color:#66615B;font-size: 14px;font-weight: 500;margin:10px;min-height:70px;">{{product.name.toLowerCase()}}</div>
              <div class="productFooter" style="margin:10px 5px;">
                <div class="priceContainer">
                  <template v-if="!product.has_presentation">
                    <div v-if="product.product_views[0].promotional_price" class="productFrom">R$ {{formatPrice(product.product_views[0].price)}}</div>
                    <div v-if="!product.product_views[0].promotional_price" class="productPrice" :style="{color: getCssColor('primary_bt')}"> R$ {{formatPrice(product.product_views[0].price)}} </div>
                    <div v-else-if="product.product_views[0].promotional_price" class="productPrice" :style="{color: getCssColor('primary_bt')}"> R$ {{formatPrice(product.product_views[0].promotional_price)}} </div>
                  </template>
                  <template v-else>
                    <div class="productFrom" style="text-decoration:none;margin-top:3px;">a partir de</div>
                    <div class="productPrice" :style="{color: getCssColor('primary_bt')}"> R$ {{formatPrice(getMinorViewPrice(product.product_views))}} </div>
                  </template>
                </div>
                <div class="buttonContainer" v-if="!product.has_presentation && !isOnCart(product.id, product.product_views[0].id)">
                  <div class="addToCart" @click="addToCart(product, product.product_views[0].id)" :style="{backgroundColor: getCssColor('primary_bt')}">
                    COMPRAR
                  </div>
                </div>
                <div class="buttonContainer" v-else-if="product.has_presentation">
                  <div class="addToCart" @click="$router.push({path:'/product/'+product.id})" :style="{borderColor: getCssColor('primary_bt'), color: getCssColor('primary_bt')}">
                    ESCOLHA
                  </div>
                </div>
                <div v-else class="plusConatiner" style="display:inline-flex;line-height:46px;max-width:67px;">
                  <div class="plus-bt" @click="minusQtd(product.id, product.product_views[0].id)">
                    <font-awesome-icon v-if="getQtd(product.id, product.product_views[0].id) > 1" style="cursor:pointer;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'minus-circle']"/>
                    <font-awesome-icon v-else style="cursor:pointer;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'trash-alt']"/>
                  </div>
                  <div class="plus-qtd" style="text-align:center;">{{getQtd(product.id, product.product_views[0].id)}}</div>
                  <div class="plus-bt" @click="plusQtd(product.id, product.product_views[0].id)"><font-awesome-icon style="cursor:pointer;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'plus-circle']"/></div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <InnerLoading v-if="loading" />
      </b-row>
    </b-container>
    <Footer v-if="showFooter"/>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
import cartMixin from '@/mixins/cartMixin'
import colors from '@/mixins/colors'
import ProductsConn from '@/connection/productsv2.js'
import CategoriesConn from '@/connection/categories.js'
import formaters from '@/mixins/formaters.js'
import CartBullet from '@/components/CartBullet.vue'
import { EventBus } from '@/behaviours/event-bus'
import StoreHeader from '@/components/StoreHeader.vue'
import Footer from '@/components/Footer.vue'
import AtacarejoSticker from '@/components/AtacarejoSticker'
import PromoSticker from '@/components/PromoSticker'
import InnerLoading from '@/components/InnerLoading'
import _ from 'lodash'

export default {
  data () {
    return {
      products: [],
      categories: [],
      name: '',
      id: this.$route.params.categoryId,
      showFooter: false,
      offset: null,
      offsetOrder: null,
      loading:false
    }
  },
  mixins: [navigation, colors, formaters, cartMixin],

  components: {CartBullet, StoreHeader, Footer, AtacarejoSticker, InnerLoading, PromoSticker},

  computed: {
    productImageURI () {
      return this.$store.getters.getProductImageURI
    }
  },

  created () {
    console.log('create categories')
    if (this.$route.params.categoryId !== this.$store.state.lastCategoryId) {
      this.$store.state.lastCategoryId = this.$route.params.categoryId
      this.$store.state.lastCategoryProds = []
      this.$store.state.lastCategoryOffset = null
      this.$store.state.lastCategoryOffsetOrder = null
    } else {
      this.products = this.$store.state.lastCategoryProds
      this.offset = this.$store.state.lastCategoryOffset
      this.offsetOrder = this.$store.state.lastCategoryOffsetOrder
    }
  },

  destroyed () {
    console.log('destroy categories')
    EventBus.$off('maxScrollY')
    EventBus.$off('keyboadOpen')
    EventBus.$off('keyboadHide')
  },

  methods: {
    resetScroll () {
      this.$store.state.lastLimitProducts = 20
      this.$store.state.breadCrumbSavedPosition = {x: 0, y: 0}
      window.scrollTo(0, 0)
    },

    async updateScrollScreem () {
      if (this.offset && !this.loading) {
        await this.getProductsByCategory()
      } else if (!this.offset && !this.loading){
        this.showFooter = true
      } else {
        this.showFooter = false
      }

      if (this.showFooter === false && !this.loading && (document.body.scrollHeight - document.body.offsetHeight === 0)) {
        await this.updateScrollScreem()
      }

    },

    startSearch () {
      // window.scrollTo(0, 0)
      //this.searchBoxModal = true
      this.$router.push({path:'/search'})
    },

    async getProductsByCategory (lastLength) {
      console.log('get products by category', this.loading)
      this.loading = true
      if (!lastLength) {
        lastLength = 0
      }
      let prods = await ProductsConn.getAllProductsByCategoryId(this.$route.params.categoryId, this.$store.state.lastLimitProducts, this.offset, this.offsetOrder)
      //console.log(prods)
      if (prods.length) {
        if (prods.length >= this.$store.state.lastLimitProducts) {
          this.offset = prods[prods.length-1].id
          this.offsetOrder = prods[prods.length-1].order
          this.$store.state.lastCategoryOffset = this.offset
          this.$store.state.lastCategoryOffsetOrder = this.offsetOrder
        } else {
          this.offset = null
          this.offsetOrder = null
          this.$store.state.lastCategoryOffset = null
          this.$store.state.lastCategoryOffsetOrder = null
        }
        // remove inactives and no stock on view 0
        // TODO stock_qtd by variable on company to show less than one
        // and check to aleert stocke
        if (this.$store.getters.getChoicedCompany.stock_configuration === true) {
          prods = prods.filter(p => p.active === true && !p.expires_at && p.product_views[0].stock_quantity > 0)
        } else {
          prods = prods.filter(p => p.active === true && !p.expires_at)
        }
        // sort
        prods.sort((a, b) => a.order - b.order)
        // merge
        this.products = _.union(this.products, prods)
        this.$store.state.lastCategoryProds = this.products

        // fix ios not scroll event on first search
        lastLength = lastLength + prods.length
        if (lastLength < this.$store.state.lastLimitProducts && this.offset) {
          console.log('not reached array size get more')
          await this.getProductsByCategory(lastLength)
        }
      } else {
        this.offset = null
        this.offsetOrder = null
        this.$store.state.lastCategoryOffset = null
        this.$store.state.lastCategoryOffsetOrder = null
      }
      this.loading = false
    }
  },

  async mounted () {

    // this.searchBoxModal = this.$store.state.activeSearch

    //infity scroll
    EventBus.$on('maxScrollY', async () => {
      this.updateScrollScreem()
    })

    let categoriesData = await CategoriesConn.getAll()
    let categories = categoriesData.data
    this.categories = categories

    if (this.$route.params.categoryId !== '0') {
      let catFilt = categories.filter(c => c.id === this.$route.params.categoryId)
      if (catFilt.length && catFilt[0].name){
        this.name = catFilt[0].name
      } else {
        this.name = 'Indefinido'
      }
    } else {
      this.name = "Todos os Produtos"
    }

    if (!this.products.length && !this.loading) {
      await this.getProductsByCategory()
      if (document.body.scrollHeight - document.body.offsetHeight === 0) {
        this.updateScrollScreem()
      }
    }

    // restore scroll after load products
    window.scroll(this.$store.state.breadCrumbSavedPosition.x,
      this.$store.state.breadCrumbSavedPosition.y)
  }


}
</script>

<style lang="scss" scoped>

@import "@/css/_variables.scss";

.foto {
  max-width:120px;
  max-height:120px;
}

.nameCapt {
  text-transform: capitalize;
}

.categotyProductBox {
  @media screen and (min-width: $tablet) {
    padding: 5px 30px 5px 20px;;
  }
}

.categotyProductBoxChild {
  @media screen and (min-width: $tablet) {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    margin:10px 5px;
    background-color:#ffffff;
    border-radius:3px;
  }
}

.productFooter {
  height:48px;
}

.productFrom {
  font-size: 16px;
  color: #807C77;
  text-decoration: line-through;
  height:24px;
}

.productPrice:only-child {
  height:48px;
  line-height:68px;
  vertical-align: text-bottom;
  font-size:16px;
}

.productPrice {
  font-size: 16px;
  font-weight: 500;
  width:80px;
  height:24px;
}

.priceContainer {
  width:60%;
  min-height:24px;
  float:left;
}

.buttonContainer {
  width:40%;
  float:right;
  text-align:center;
}

.addToCart {
  text-align:center;
  border:1px solid;
  padding:5px;
  border-radius:4px;
  font-size:11px;
  font-weight:500;
  color:#ffffff;
  cursor:pointer;
  margin:18px 0 0 0;
  @media screen and (min-width: $tablet) {
    margin:18px 7px 0 0;
  }
}

.containerCategories {
  position: relative;
  width: 100vw;
  margin: 0;
  @media screen and (min-width: $tablet) {
    background-color:#F5F6F7;
  }
}


.categoryHeader {
  z-index:12000;
  position: fixed;
  width:100%;
  top: -20px;
  height:85px;
  .headerItem {
    margin-top:30px;
    line-height:60px;
    text-align:center;
    padding-left:10px!important;
    padding-right:10px!important;
  }

}

.categorySearchHeader {
  z-index:12000;
  position: fixed;
  position:device-fixed;
  width:100%;
  top: -2vh;
  height:120px;
  background-color: #2C2A29;
  color:#ffffff;
  font-weight:500;
  .headerItem {
    margin-top:50px;
    text-align:center;
    height:30px;
    line-height:30px;
  }

}


.categoriesBox {
  background-color: #F4F4F4;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  // -webkit-overflow-scrolling: touch;
  // -webkit-box-shadow:0 1px 2px rgba(0, 0, 0, 0.2);
  // -moz-box-shadow:0 1px 2px rgba(0, 0, 0, 0.2);
  // box-shadow:0 1px 2px rgba(0, 0, 0, 0.2);
  width: 100%;
}
.categoriesBox [class*="span"] {  /* TWBS v2 */
  display: inline-block;
  float: none; /* Very important */
  color: #66615B;
  text-align:center;
}

.selectedCat {
  border-bottom: 2px solid;
  font-weight: 500;
}

.plusConatiner {
  margin: 12px auto;
  text-align:center;
  .plus-bt {
    font-size:18px;
  }
  .plus-qtd {
    font-size:14px;
    width:24px;
    font-weight: 500;
  }
}


</style>
